import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "cockpit-page" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = { class: "list" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_8 = {
  key: 1,
  class: "empty"
}

import { computed, onMounted, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { toast } from "@/common/utils/toast";
import store from "@/store";

import {
  evaluationList,
  evaluationCreate,
} from "@/common/api/rest/evaluation/evaluation";

import type { EvaluationListType } from "@/common/types/evaluation";

import { PanelTheme } from "@/common/themes";

import {
  baseConfirm,
  cardEvaluation,
  baseInput,
  baseLoading,
  baseSelect,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const listRef = ref();
const searchInput = ref("");
const statusType = ref("PROGRESS");

const evaluations = ref<EvaluationListType[]>([]);

const loading = ref(false);
const hasScroll = ref(false);
const showModalAdd = ref(false);

const accountId = computed(() => route.params.id as string);
const userType = computed(() => store.getters.type as string);

const statusOptions = computed(() => [
  {
    option: t("evaluation.labels.in_progress"),
    value: "PROGRESS",
  },
  {
    option: t("evaluation.labels.started"),
    value: "STARTED",
  },
  {
    option: t("evaluation.labels.pending"),
    value: "PENDING",
  },
  {
    option: t("evaluation.labels.concluded"),
    value: "CONCLUDED",
  },
  {
    option: t("evaluation.labels.canceled"),
    value: "CANCELED",
  },
]);

function checkPermissions() {
  if (
    !userType.value ||
    userType.value === "ADMIN" ||
    userType.value === "MANAGER"
  )
    return;

  toast({ message: t("error.unauthorized"), type: "error" });
  router.push(`/${accountId.value}/home`);
}

function checkScroll() {
  if (!listRef.value) return false;

  hasScroll.value = listRef.value?.scrollHeight > listRef.value?.clientHeight;
}

async function fetchData() {
  if (!accountId.value) return;

  loading.value = true;

  evaluationList(accountId.value, {
    full: true,
    status: statusType.value,
    search: searchInput.value,
  })
    .then((response) => {
      const { success, data } = response;

      if (success) {
        evaluations.value = data.list;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      loading.value = false;
      checkScroll();
    });
}

function addItem() {
  showModalAdd.value = true;
}

function addItemCancel() {
  showModalAdd.value = false;
}

function addItemConfirm() {
  showModalAdd.value = false;
  store.commit("SET_LOADING", true);

  evaluationCreate(accountId.value, {
    member_id: store.getters.user.member_id,
  })
    .then((response) => {
      const { success, data } = response;

      if (success) {
        fetchData();
        addItemCancel();
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function selectEvaluation(evaluation: EvaluationListType) {
  router.push(`/${accountId.value}/cockpit/${evaluation.evaluation_id}`);
}

function cleanSearch() {
  if (!searchInput.value) {
    fetchData();
  }
}

function searchValue() {
  fetchData();
}

function changeStatus() {
  localStorage.setItem("cockpit-status", statusType.value);

  fetchData();
}

watchEffect(() => {
  checkPermissions();
});

onMounted(() => {
  const status = localStorage.getItem("cockpit-status");
  statusType.value = status || "PROGRESS";

  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelTheme), null, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createVNode(_unref(baseSelect), {
            modelValue: statusType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((statusType).value = $event)),
            value: statusType.value,
            options: statusOptions.value,
            "is-empty": false,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (changeStatus()))
          }, null, 8, ["modelValue", "value", "options"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(baseInput), {
              modelValue: searchInput.value,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((searchInput).value = $event)),
                _cache[4] || (_cache[4] = ($event: any) => (cleanSearch()))
              ],
              background: "#fff",
              color: "#000",
              placeholder: _unref(t)('common.labels.search'),
              "onKey:enter": _cache[5] || (_cache[5] = ($event: any) => (searchValue()))
            }, {
              sufix: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(svgIcon), {
                    icon: "search",
                    size: "1.75rem",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (searchValue()))
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btn btn-md btn-primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (addItem()))
            }, [
              _createVNode(_unref(svgIcon), {
                icon: "add",
                size: "1.1rem"
              }),
              _createElementVNode("span", null, _toDisplayString(_unref(t)("common.labels.evaluation")?.toUpperCase()), 1)
            ])
          ])
        ]),
        _createElementVNode("section", {
          ref_key: "listRef",
          ref: listRef,
          class: _normalizeClass(["evaluations", { scrollable: hasScroll.value }])
        }, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(evaluations.value, (evaluation) => {
              return (_openBlock(), _createBlock(_unref(cardEvaluation), {
                key: evaluation.evaluation_id,
                evaluation: evaluation,
                onClick: ($event: any) => (selectEvaluation(evaluation))
              }, null, 8, ["evaluation", "onClick"]))
            }), 128))
          ]),
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_unref(baseLoading))
              ]))
            : _createCommentVNode("", true),
          (!loading.value && evaluations.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)("evaluation.texts.empty_evaluation")), 1))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createVNode(_unref(baseConfirm), {
        show: showModalAdd.value,
        title: _unref(t)('evaluation.modal.titles.add_evaluation').toUpperCase(),
        message: _unref(t)('evaluation.modal.messages.add_evaluation'),
        onCancel: _cache[7] || (_cache[7] = ($event: any) => (addItemCancel())),
        onConfirm: _cache[8] || (_cache[8] = ($event: any) => (addItemConfirm()))
      }, null, 8, ["show", "title", "message"])
    ]),
    _: 1
  }))
}
}

})